import EventModule from '../../module/event';

export default (html, data) => {
    var isRandom = html.attr('items-html-event-random') || html.attr('data-is-item-block'),
        isRandom = isRandom !== undefined ? true : false;

    let imageHtml = '<img src="' + data.image + '">';

    if (data.isLive) {
        imageHtml += '<div class="event-item__live-badge">live</div><div class="event-item__play-btn"></div>';
        html.find('[hide-is-live]').hide();
    }

    html.find('[html-image]').html(imageHtml);

    if (data.industry != null) {
        if (data.industry.id == 15) {
            html.find('[html="industry.name"]').html('IT, ТВ, Мода, Кино, +10');
        }

        html.find('[attr-industry-color]').css('background', data.industry.color);
    }

    if (data.attendees != null) {
        $.each(data.attendees, function (i, speaker) {
            if (isRandom) {
                html.find('[html-speakers]').append((i ? ', ' : '') + speaker.name);
            } else {
                html.find('[html-speakers]').append('<div class="event-item__speaker">' + speaker.name + '' + (i == 4 && data.attendees_plus ? ', +' + data.attendees_plus : '') + '</div>');
            }
        });

        var speakersElem = isRandom
            ? html.find('[html-speakers]')
            : html.find('[html-speakers-mobile]');

        speakersElem.html('');

        $.each(data.attendees, function (i, speaker) {
            speakersElem.append((i > 0 ? ', ' : '') + speaker.name);

            if (i == 1 && data.attendees_plus_mobile) {
                speakersElem.append(', +' + data.attendees_plus_mobile);
                return false;
            }
        });

        html.find('[html-speakers-mobile]').parent().show();
    }

    html.find('[data-event-calendar]').attr('data-event-calendar', data.id);

    EventModule.btnText(data.id, data.inCalendar, html);

    return html;
}